export default class MeetingStatusDomainService {
    static get Cancelled() {
        return {
            id: 1,
            name: "Cancelled",
        };
    }
    static get Scheduled() {
        return {
            id: 2,
            name: "Scheduled",
        };
    }
    static get NoShow() {
        return {
            id: 3,
            name: "No Show",
        };
    }
    static get Completed() {
        return {
            id: 4,
            name: "Completed",
        };
    }
    // export class MeetingStatusDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static getBadgeColor(meetingStatus) {
        switch (meetingStatus && meetingStatus.id) {
            case MeetingStatusDomainService.Cancelled.id:
                return "danger";
            case MeetingStatusDomainService.NoShow.id:
                return "info";
            case MeetingStatusDomainService.Scheduled.id:
                return "warning";
            case MeetingStatusDomainService.Completed.id:
                return "success";
            default:
                throw new Error("Invalid meeting status provided");
        }
    }
}
